import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_BEFORE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/gymklar';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-218" data-mp="1mm7imuvep9ed">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-219" data-mp="1hpqva2w16z2c">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-220" data-mp="tzwfpdkbuwee">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-221" data-mp="ozrz7njf61o6">
            Oppdag hele <em className="text-red-300" data-id="element-222" data-mp="13wre7wglowso">GOLFKLAR™</em>-pakken
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-223" data-mp="13uy60cqca4ik">
            Hele golfsesongen – ferdig planlagt, ute og inne. Klar til gruppetrening på 5 minutter.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-224" data-mp="2feaog8slm00q" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-225" data-mp="pkh5572t4oe3">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-226" data-mp="uhqu6lmaay1e">Hele pakken inneholder</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-227" data-mp="zjputnqn3gun">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-228" data-mp="13j73sr59yw4k">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-229" data-mp="6uiq270ldv0y">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-230" data-mp="btlwnvw809b1" />
                </span>
                <span data-id="element-231" data-mp="ft4geocb2eca">
                  <span className="block font-medium leading-snug" data-id="element-232" data-mp="kl49bwtyk6zd">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-233" data-mp="kn8o59teaqef">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-234" data-mp="3o96023cyjgrc">
            <div className="sm:pb-2" data-id="element-235" data-mp="vde7b2r0ny4l">
              <p className="text-sm font-medium text-slate-900/70" data-id="element-236" data-mp="qhfl9lt5us7c">Introduksjonspris</p>
              <p className="mt-1 text-base text-slate-900/60" data-id="element-237" data-mp="1561zfk71xdwz">
                Før <s className="decoration-red-700 decoration-2" data-id="element-238" data-mp="157d5jqnyyxr9">{PRICE_BEFORE}</s>
              </p>
            </div>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-239" data-mp="cgv04izrwkao">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-240" data-mp="7jcsqx1emd4s">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-241" data-mp="livwzer3h4bt" />
            Engangsbetaling. Ingen abonnement.
          </p>

          <CtaButton label="Få hele pakken nå" className="mt-8 w-full" data-id="element-242" data-mp="1wwg91481842u" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-243" data-mp="1wysys3k17iqg">
            {offerIncludes.map(item => <li key={item} data-id="element-244" data-mp="20exbwbz1wbzb">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}